import { camelizedJSONFetch } from '../fetchShim';
import type { UserData } from './types';

export const getCurrentUser = async () => camelizedJSONFetch<UserData>(
  '/dashboard/current-user-data',
);
